import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../common/Loader';
import { cancelRazorpaySubscription, fetchSubscriptionPlanById } from './api';
import dayjs from 'dayjs';
import { updateUser } from 'src/features/user/userSlice';

const ExistingSubscription = () => {
  const [planData, setPlanData] = useState({});
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  const userData = useSelector((state) => state.user.user);
  const subStatus = userData?.subscriptionStatus;
  const currentPlanId = userData?.clinicData?.planId;

  useEffect(() => {
    const getPlanDetails = async () => {
      setLoader(true);
      try {
        const planDetails = await fetchSubscriptionPlanById(currentPlanId);
        if (planDetails) {
          setPlanData(planDetails);
          console.log("Fetched plan details: ", planDetails);
        }
      } catch (error) {
        console.error("Error fetching plan details: ", error);
      } finally {
        setLoader(false);
      }
    }

    getPlanDetails();
  }, [currentPlanId])

  const handleCancel = async () => {
    setLoader(true);
    try {
      const resp = await cancelRazorpaySubscription(userData?.clinicId);
      if (resp) {
        console.log("Subscription cancelled successfully", resp);
        dispatch(updateUser({ field: 'subscriptionStatus', value: 'cancelled', }))
      }

    } catch (error) {
      console.error("Error cancelling subscription: ", error);
    } finally {
      setLoader(false);
    }
  }

  return (
    <>
      <Helmet>
        <title>Subscription | DOCG</title>
      </Helmet>
      <Loader show={loader} />
      <Card className='docg-card docg-patient-form-wrapper p-0 h-standard mx-2'>
        <Card.Header className='cardHeaderUsed'>
          <Card.Title className="cardTitleUsed">Current Subscription Details</Card.Title>
        </Card.Header>
        <Card.Body className="d-flex flex-column gap-2 py-4 px-2 fs-6">
          <div className="mbsc-row">
            <div className="mbsc-col-3 fw-500">Plan:</div>
            <div className="mbsc-col-9">
              {/* {list[0].planDetails == null && "No Data Found"} */}
              {planData?.planId}
              <br />
              {planData?.item?.name} <br />
              {planData?.item?.description} <br />
              &#8377; {(planData?.item?.amount / 100).toLocaleString()}{" "}
              Billed Every {planData?.interval}{" "}
              {planData?.period?.split("ly")[0]}s <br />
            </div>
          </div>

          {/* <div className="mbsc-row mt-2">
            <div className="mbsc-col-3">Link</div>
            <div className="mbsc-col-3">
              <a href={list[0].shortUrl} target="_blank" rel="noreferrer" style={{ color: 'blue' }}>
              <u>{list[0].shortUrl}</u>
            </a>
            </div>
          </div> */}

          <div className="mbsc-row mt-2">
            <div className="mbsc-col-3 fw-500">Status:</div>
            <div style={{ textTransform: "capitalize" }} className="mbsc-col-9 d-flex gap-2">
              <button type="button" className="docg-outline-btn mr-2">
                {subStatus}{" "}
              </button>
              <button onClick={handleCancel} className="docg-outline-btn">
                Cancel Subscription
              </button>
            </div>
          </div>

          <div className="mbsc-row mt-2">
            <div className="mbsc-col-3 fw-500">Created At:</div>
            <div className="mbsc-col-9">{dayjs.unix(planData?.item?.createdAt).format("D MMMM, YYYY hh:mm a")}</div>
          </div>
          {/* <div className="mbsc-row mt-2">
            <div className="mbsc-col-3">Next due on</div>
            <div className="mbsc-col-9">{dayjs.unix(planData?.item?.updatedAt).format("D MMMM, YYYY hh:mm a")}</div>
          </div> */}
        </Card.Body>
      </Card>
    </>
  )
}

export default ExistingSubscription;